import { Button, CircularProgress, Snackbar } from "@mui/joy";

import { ExclamationIcon } from "components/ui/icons";
import { FirebaseError } from "firebase/app";
import React from "react";
import { auth } from "firebase-config";
import { useAlert } from "hooks";

function DeleteAccount() {
  const { openAlert, handleOpenAlert, handleCloseAlert, alertMessage, setAlertMessage } = useAlert();
  const [loading, setLoading] = React.useState<boolean>(false);

  const onDeletePressHandler = async () => {
    setLoading(true);
    try {
      await auth.currentUser?.delete();
    } catch (error) {
      const typedError = error as FirebaseError;
      handleOpenAlert();
      setAlertMessage({
        title: "Error",
        message: typedError?.message ?? error,
        color: "danger",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="h-screen p-6 overflow-auto bg-gray-200">
        <div className="max-w-xl p-6 mx-auto mb-8 bg-white shadow-md rounded-xl">
          <div className="w-full mb-4 text-lg font-bold text-center">DELETE ACCOUNT</div>
          <div className="w-full mb-8 text-md text-center">
            This procedure will delete your account and data associated to it. Please be aware that this action is final
            and cannot be reverted.
          </div>
          <div className="flex flex-col max-w-sm gap-4 mx-auto mb-8">
            <Button variant="solid" onClick={onDeletePressHandler}>
              Delete
              {loading && <CircularProgress variant="plain" sx={{ position: "absolute" }} />}
            </Button>
          </div>
        </div>
      </div>
      <Snackbar
        variant="solid"
        color={alertMessage.color}
        open={openAlert}
        onClose={handleCloseAlert}
        autoHideDuration={3000}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        startDecorator={<ExclamationIcon />}
      >
        {alertMessage.message}
      </Snackbar>
    </>
  );
}

export default DeleteAccount;
